module.exports = __webpack_public_path__ + "img/search-black.cdc24f4a.svg";